import { Button, ButtonStyle, DEFAULT_HEADING, DEFAULT_SUBHEADING, EditImage, EdiText, Form, Formik,
         Checkbox, Select, getCustomizeCareerData, handleBackgroundOnChange, PageStyle,
         updateHeader, updateSubheader,  useEffect, useRouter, useState,
         ClientDashboard, SkipModal, ActivitiesAction, ErrorPages, SidebarAction, useSWR,
         useTranslation, Header, Footer, HeroSection, CustomizeCareerAction, NextServerCookies, CustomizeCareerService, LINK_TYPES, OpenJobs
         , About, Gallery, Benefit, MeetTeam, GoogleFontLoader}  from '@/imports-files/pages/career/customize-career-page';
import { findJob, ShowJobAction} from '@/imports-files/pages/clients/careers/showJob';
import Head from 'next/head'

function ShowJob({job_data, status_code})
{
  const router  =     useRouter();
  if(status_code != 200) return new ErrorPages().renderPage(status_code, router)
  const url  = (typeof window != "undefined") ? window?.location?.href : ''
  const career_page = job_data.career_page
  const showJobAction =  new ShowJobAction();
  const customizeCareerAction = new CustomizeCareerAction({formRef: {current: {values: career_page}}});
  const [flagForRender, setFlagForRender] = useState(0);
  const [fonts, setFonts] = useState([])
  useEffect(async () => {
    customizeCareerAction.bannerSize();
    setFonts(customizeCareerAction.listofAllFonts(career_page));
    window.addEventListener("resize", () => {
      customizeCareerAction.bannerSize();
      setFlagForRender(Math.random() * 10000);
    });
    return () => {
      window.removeEventListener("resize", () => {
            customizeCareerAction.bannerSize();
        });
    }
  }, [])

  function render_page_section(page_section, index, formik, customizeCareerAction) {
    let section_type = page_section.type
    switch(section_type){
    case 'about':
      return <About
        page_section={page_section}
        customizeCareerAction={customizeCareerAction}
        formik={formik}
        index={index}
        isPreview={true}
      />
      break;
    case 'benefit':
      return <Benefit
        page_section={page_section}
        customizeCareerAction={customizeCareerAction}
        formik={formik}
        index={index}
        isPreview={true}
        />
      break;
    case 'team':
      return <MeetTeam
        page_section={page_section}
        customizeCareerAction={customizeCareerAction}
        formik={formik}
        index={index}
        isPreview={true}
      />
      break;
    case 'gallery':
      return <Gallery
        page_section={page_section}
        formik={formik}
        customizeCareerAction={customizeCareerAction}
        index={index}
        isPreview={true}
        />
      break;
    case 'job':
      return <OpenJobs
        isPreview={true}
        formik={formik}
        customizeCareerAction={customizeCareerAction}
        index={index}
        job_data={job_data}
        isPublic={true}
        page_section={page_section}
        isFrame={false}
        hide_title={"false"}
       />
      break;
    }
  }
  return(
    <>
      <Head>
        <meta property="og:type" content="article" />
        {career_page.hero_section_attributes.title && <meta property="og:title"  content={career_page.hero_section_attributes.title} name="title" /> }
        {career_page.client_name && <meta property="og:description" content={career_page.client_name} name="description" />}
        {url && <meta property="og:url" content={url} />}
        {career_page.meta_image_url && <meta property="og:image" key="image" content={career_page.meta_image_url}  />}
        {career_page.meta_image_url && <meta property="og:image" name="image"  content={career_page.meta_image_url}/>}
        {career_page.meta_image_url && <meta property="twitter:image" name="image"  content={career_page.meta_image_url}/>}
      </Head>
      <Header
        formik={{values: career_page}}
        customizeCareerAction={customizeCareerAction}
        isPreview={true}
        isPublic={true}
      />
      <HeroSection
        formik={{values: career_page}}
        customizeCareerAction={customizeCareerAction}
        isPreview={true}
      />
      {
        career_page.page_sections_attributes.map((page_section, index) => {
          return render_page_section(page_section, index, {values: career_page}, customizeCareerAction)
        })
      }
      <Footer
        formik={{values: career_page}}
        customizeCareerAction={customizeCareerAction}
        isPreview={true}
      />
      {fonts.length > 0 && <GoogleFontLoader
        fonts={fonts}
      />}
    </>
  )
}


export async function getServerSideProps(context) {
  const { req, res }          =  context
  const body                  =  {host_name: req.headers.host};
  const result              =  await new findJob().getJobsData(body) || null;
  const status_code = result.status || result.response.status;
  const job_data   =  result?.data || {}

  return {
    props: {
               job_data,
               status_code
            }
  }
}


export default ShowJob;